import { FC, ReactNode, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { cx } from '@emotion/css';

import { useStyles } from './benefit.styles';
import { SimulatorBenefitProps } from '../simulator.models';
import topLeft from '../../../../assets/images/icons/arrow/pointer-top-left.svg';
import topRight from '../../../../assets/images/icons/arrow/pointer-top-right.svg';
import bottomLeft from '../../../../assets/images/icons/arrow/pointer-bottom-left.svg';
import bottomRight from '../../../../assets/images/icons/arrow/pointer-bottom-right.svg';

export const SimulatorBenefit: FC<SimulatorBenefitProps> = ({ content, arrowPosition, position }): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();

  const url = useMemo(() => {
    switch (arrowPosition) {
      case 'top-left':
        return topLeft;
      case 'bottom-right':
        return bottomRight;
      case 'top-right':
        return topRight;
      default:
        return bottomLeft;
    }
  }, [arrowPosition]);

  return (
    <div className={classes.root} style={{ top: `${position.y}%`, left: `${position.x}%` }}>{intl.formatMessage(
      { id: content },
      {
        strong: (chunks: ReactNode) => <strong className={classes.strong}>{chunks}</strong>,
        sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
      },
    )}
      <img
        className={cx(classes.arrow, arrowPosition)}
        src={url}
        alt=""
        aria-hidden="true"
      />
    </div>
  );
};
